import { Common } from '@stockbit/ui';
import color from 'global/StyleDefinition/Color';
import Link from 'next/link';
import plans from './constants';
import {
  Subtitle,
  Title,
  Box,
  BoxContainer,
  PlanContainer,
  Button,
  BigText,
} from './styled';

const { Text } = Common;

const PricingPlan = () => (
  <PlanContainer>
    <Subtitle>Pricing Plan</Subtitle>
    <Title>
      Berbagai pilihan berlangganan terbaik untuk mendukung kegiatan investasimu
    </Title>
    <BoxContainer>
      {plans.map((plan) => (
        <Box key={plan.key}>
          <div>
            <BigText>{plan.per}</BigText>
            <Text as="p" size="17px" align="center">
              {plan.description}
            </Text>
          </div>
          <div>
            <Text as="span" size="17px">
              Rp
            </Text>
            <BigText className="price">{plan.price}</BigText>
            <Text color={color.midgray} as="p" size="12px" align="center">
              per bulan
            </Text>
            <Link href="/register" passHref>
              <Button>Subscribe</Button>
            </Link>
          </div>
        </Box>
      ))}
    </BoxContainer>
  </PlanContainer>
);

export default PricingPlan;
